import { TooltipDesktop, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import disclaimerIcon from './assets/disclaimerIcon.svg';
import * as style from './mortgage.css';

export interface IAdFoxBannerContext {
  [key: string]: string;
}

export type TMortgageSimpleBannerProps = {
  context: IAdFoxBannerContext;
};

export class MortgageSimpleBanner extends React.PureComponent<TMortgageSimpleBannerProps> {
  public render() {
    const {
      context: { reference, text, label, annotation, withReference },
    } = this.props;

    return (
      <div className={style['root']}>
        {withReference === '1' ? (
          <span className={classNames(style['link'])}>{text}</span>
        ) : (
          <a
            data-mark="MortgageSimpleBannerLink"
            href={reference}
            target={'_blank'}
            className={classNames(style['link'])}
            rel="noreferrer"
          >
            {text}
          </a>
        )}
        {label && !annotation && <div className={style['label']}>{label}</div>}
        {annotation && (
          <TooltipDesktop
            title={<UIText2 color="gray40_100">{annotation}</UIText2>}
            placement={'bottom'}
            theme={'white'}
          >
            {label ? (
              <div className={style['label']}>{label}</div>
            ) : (
              <img className={style['info']} src={disclaimerIcon} alt={'info_icon'} />
            )}
          </TooltipDesktop>
        )}
      </div>
    );
  }
}
